import React from "react";
import { DeleteDialog } from "../../components";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  canDelete: boolean
  type: server.dto.MessageTemplateTypes
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  templateId: number
}

const InvitationTemplateOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const [isCopying, setIsCopying] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.MessageTemplate.Delete({
      messageTemplateId: props.templateId
    });

    window.location.href = `${props.listUrl}?type=${props.type}`;
  };

  const onCopy = async () => {
    const res = await window.CoreApi.MessageTemplate.Copy({
      messageTemplateId: props.templateId
    });
    return res.data;
  }

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: `${props.listUrl}?type=${props.type}`,
          text: RESX.Buttons.ListView,
          visible: true
        },
        {
          onClick: () => { setIsCopying(true); },
          text: RESX.Buttons.btnCopy,
          visible: true,
        },
        {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: props.canDelete,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ConfirmCopyModal
      isOpen={isCopying}
      apiCall={onCopy}
      onClose={() => { setIsCopying(false); }}
      onSuccess={(itemId) => window.location.href = routes.messageTemplate_Detail(itemId).absolute}
    />
  </>;
};

export default InvitationTemplateOptionsPanel;